import React from 'react';
import SelectField from 'material-ui/SelectField'


export const renderSelectField = ({
                               input,
                               label,
                               meta: {touched, error},
                               children,
                               ...custom
                           }) => (
    <SelectField
        floatingLabelText={label}
        errorText={touched && error}
        {...input}

        onChange={(event, index, value) => input.onChange(value)}
        children={children}
        {...custom}
        style={{fontSize:'14px'}}
    />
)


// WEBPACK FOOTER //
// ./src/components/fields/SelectField.js